import { HttpClient } from '@angular/common/http';
import { APIBaseManager } from '../../api.base';
import { ITicketData } from './api.ticket.common';

export interface ICancelTicketPathParameter {
    ticketID: string;
}

export class APICancelTicketManager extends APIBaseManager<ICancelTicketPathParameter, void, void, ITicketData> {
    constructor(protected http: HttpClient) {
        super(http);
        this._apiName = 'API_CancelTicket';
        this._apiMethod = 'DELETE';
    }

    protected getRequestURL(pathParameters: ICancelTicketPathParameter, queryParameters: void): string {
        return super.getRequestURL() + 'accounts/tickets/' + pathParameters.ticketID;
    }
}